import React, { useEffect, useState } from 'react';
import Input from '../../components/general/input/Input';
import HelpIcon from '../../assets/images/mini/question_red.png';
import CompanyLogo from '../../assets/images/NicoLetrasAniversario.webp';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { EmailAuthProvider, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import Footer from '../../components/general/footer/Footer';
import { auth } from '../../firebase/Firebase';
import LoadingScreen from '../../components/general/loading/LoadingScreen';

export default function Login() {

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [logError, setLogError] = useState("");
  const [load, setLoad] = useState(false);

  const [firstLoad, setFirstLoad] = useState(true);
  
  let navigate = useNavigate();

  useEffect(() => {
    document.title = "Iniciar Sesión"

    if(firstLoad){
      onAuthStateChanged(auth, handleUserStateChange)
    }
  })

  function handleUserStateChange(user){
    setFirstLoad(false);
    if(user){
      //navigate("/")
    }else{
      console.log("No hay nadie autenticado.. ")
    }
  }

  async function handleEmailLogin(){
    const emailProvider = new EmailAuthProvider();
    if(email.match(/@/i) != null && email.match(/./i) != null && pass !== ""){
      setLoad(true);
      await signInWithEmail(emailProvider);
      setLoad(false);
    }else if(email.match(/@/i) == null && email.match(/./i) == null){
      setLogError("Inserte un email valido");
    }else if(pass === ""){
      setLogError("Inserte una contraseña");
    }
  }
  
  async function signInWithEmail(emailProvider){
    let correctedEmail = email.toLowerCase();
    correctedEmail.replace(" ", "")
    try{
      await signInWithEmailAndPassword(auth, correctedEmail, pass);
      //console.log(res);
      //navigate("../");
    }catch (error) {
      console.error(error);
      if(error.message === "Firebase: Error (auth/invalid-email)."){
        setLogError("Email o contraseña incorrectos");
      }else if(error.message === "Firebase: Error (auth/wrong-password)."){
        setLogError("Email o contraseña incorrectos");
      }else if(error.message === "Firebase: Error (auth/user-not-valid)."){
        setLogError("El usuario al que intenta acceder no existe");
      }else if(error.message !== null){
        setLogError(error.message);
      }
    }
  }

  /*
  async function handleGoogleLogin(){
    const googleProvider = new GoogleAuthProvider();
    setLoad(true);  
    await signInWithGoogle(googleProvider);
    setLoad(false);
  }*/

  async function signInWithGoogle(googleProvider){
    try{
      //await signInWithPopup(auth, googleProvider);
      navigate("../");
    }catch (error) {
      console.error(error);
      if(error.message === "Firebase: Error (auth/invalid-email)."){
        setLogError("Email o contraseña incorrectos");
      }else if(error.message === "Firebase: Error (auth/wrong-password)."){
        setLogError("Email o contraseña incorrectos");
      }else if(error.message === "Firebase: Error (auth/user-not-valid)."){
        setLogError("El usuario al que intenta acceder no existe");
      }else if(error.message !== null){
        setLogError(error.message);
      };
    }
  }

  return (
    <div className='Login'>
        <div className='login-page'>
            {load && <LoadingScreen />}
            <img src={CompanyLogo} alt='Logo de Aniversario 60 años de Nicolini Refrigeración'/>
            <h2>Iniciar Sesión</h2>
            <Input title="E-Mail" setInput={setEmail} />
            <Input title="Password" type="password" setInput={setPass} />
            <p className='error-message'>{logError !== "" && <img className="mini-icon" src={HelpIcon} alt='Ayuda'/>}{logError !== "" && logError}</p>
            <a href='/passrecover'>¿Olvidaste tu contraseña?</a>
            <ButtonMinimalist text="Iniciar Sesión" onClick={handleEmailLogin}/>
            <ButtonMinimalist text="Registrarse" id="register-switch" onClick={() => navigate("../register")}/>
        </div>
        <Footer />
    </div>
  )
}
